import React, { useState, useEffect } from "react";
import { Input } from "semantic-ui-react";

const InputField = (props) => {

    useEffect(() => {
    }, []);

    const handleOnChange = (e) => {
        props.data.lr_no = e.target.value
    };

    return (
        <>
            <Input
                className="width-100cent"
                type="text"
                onChange={(e) => handleOnChange(e)}
            />
        </>
    );
}

export default InputField;
